import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { NewPasswordForm } from '../components/auth/NewPasswordForm';

// DEC-RBAC-055: el flujo vive en el store (sessionStorage), no en la URL. Estos search params
// quedan opcionales como fallback deprecado para deep-links viejos.
const schema = z.object({
    session: z.string().min(1).optional(),
    email: z.string().email().optional(),
    tenantId: z.string().optional(),
});

export const Route = createFileRoute('/login/new-password')({
    validateSearch: (s: Record<string, unknown>) => schema.parse(s),
    component: NewPasswordRoute,
});

function NewPasswordRoute() {
    const { session, email, tenantId } = Route.useSearch();
    // AuthLayout lo provee el parent /login vía <Outlet />.
    return <NewPasswordForm session={session} email={email} tenantId={tenantId} />;
}
